"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["for"];
const _hoisted_2 = { class: "relative w-full flex flex-row items-center" };
const _hoisted_3 = ["id", "name", "placeholder", "autofocus", "required", "value", "disabled", "readonly", "maxlength", "rows"];
const _hoisted_4 = {
    key: 1,
    class: "text-red mt-2 text-sm"
};
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TextareaInput',
    props: {
        name: String,
        placeholder: {
            type: String,
            required: false,
            default: "",
        },
        label: {
            type: String,
            required: false,
            default: "",
        },
        autofocus: Boolean,
        required: Boolean,
        showValidity: {
            type: Boolean,
            default: false,
        },
        valid: {
            type: Boolean,
            default: true,
            required: false
        },
        invalidMessage: {
            type: String,
            required: false,
            default: ''
        },
        modelValue: {
            type: String
        },
        disableFocusRing: {
            type: Boolean,
            default: false,
        },
        border: {
            type: Boolean,
            default: false,
        },
        disabled: Boolean,
        readonly: Boolean,
        maxLength: {
            type: Number,
            required: false
        },
        rows: {
            type: Number,
            default: 2
        },
        labelClass: {
            type: String,
            default: 'block pb-2 font-bold uppercase tracking-wide text-sm'
        },
        textareaExtraClass: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: () => { var _a; return `textarea-input-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; }
        }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit }) {
        const props = __props;
        const emitModelValue = (event) => {
            const target = event.target;
            if (target instanceof HTMLTextAreaElement) {
                emit('update:modelValue', target.value);
            }
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                for: __props.id,
                class: "flex flex-col w-full justify-center"
            }, [
                (__props.label)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                        key: 0,
                        class: (0, vue_2.normalizeClass)(__props.labelClass)
                    }, (0, vue_2.toDisplayString)(__props.label), 3))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("textarea", {
                        id: __props.id,
                        name: __props.name,
                        placeholder: __props.placeholder,
                        autofocus: __props.autofocus,
                        required: __props.required,
                        class: (0, vue_2.normalizeClass)(["block py-2 px-2 w-full h-full placeholder-gray-dark outline-none transition-all duration-300 disabled:bg-gray text-[15px]", {
                                'border': __props.border,
                                'border-gray-dark': __props.border,
                                'border-opacity-50': __props.border,
                                'focus:border-blue': __props.border,
                                'focus:ring-4': !__props.disableFocusRing,
                                'focus:ring-blue': !__props.disableFocusRing,
                                'focus:ring-opacity-50': !__props.disableFocusRing,
                                'border-green': __props.valid && __props.showValidity,
                                'border-red': !__props.valid && __props.showValidity,
                                'h-[50px]': __props.rows === 1,
                                [__props.textareaExtraClass]: true
                            }]),
                        value: __props.modelValue,
                        onInput: emitModelValue,
                        disabled: __props.disabled,
                        readonly: __props.readonly,
                        maxlength: __props.maxLength,
                        rows: __props.rows
                    }, "\n            ", 42, _hoisted_3)
                ]),
                (__props.showValidity && __props.invalidMessage !== '' && !__props.valid)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, (0, vue_2.toDisplayString)(__props.invalidMessage), 1))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 8, _hoisted_1));
        };
    }
});
